module.exports = __webpack_public_path__ + "img/tabbar-training-active.156c78a.svg";